import React, { useEffect } from 'react'
import { ClaroModalCustom, ClaroCardSimple } from "@claropay/shared";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PaymentMethodsList from '../../../molecules/SelectCardAnonimous/PaymentMethodsList';
import AddCardForm from '../../../molecules/SelectCardAnonimous/AddCardForm';
import { executeTaggeo, setAddCardFormData } from '../../../../store/actions';
import { getServicesTelcel } from '../../utils';
import TokenizationCardContainer from '../../../containers/TokenizationCardContainer';
import { useClaropaySdk } from "../../../../services/sdk/SDKServiceWeb.tsx";

const SelectCardAnonimous = (props) => {

	const [isEmailBackgroud, seTIsEmailBackgroud] = React.useState(false);

	const sendTaggeoBack = () => {
		if (props.canMultiAnalytics && props.isContainerTelcel) {
				const originAnalyticArray = props.originAnalytic? props.originAnalytic.split(",") : [];
				props.executeTaggeo({
					eventName: "pay_service_or_tae",
					seccion: "servicios",
					subseccion: props.serviceInfo && props.serviceInfo.serviceId && getServicesTelcel(props.serviceInfo.serviceId),
          origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
					pantalla: "formulario de pago",
					nombreServicio: props.serviceInfo && props.serviceInfo.serviceName ,
					tipoElemento: "boton",
					tagTipoElemento: "modal",
					nombreElemento: "back",
					trackAction: true,
					isTelcel: true
				}, true);
		} else {
			props.executeTaggeo({
				step: "Formulario de pago",
				action: "Click modal Back",
				modal_id: "Ingresa una tarjeta"
			});
		}
	}

	const sendTaggeoClose = (type) => {
		if (props.canMultiAnalytics && props.isContainerTelcel) {
			const originAnalyticArray = props.originAnalytic? props.originAnalytic.split(",") : [];
			if(type ==="modal") {
				props.executeTaggeo({
					eventName: "pay_service_or_tae",
					seccion: "servicios",
					subseccion: props.serviceInfo && props.serviceInfo.serviceId && getServicesTelcel(props.serviceInfo.serviceId),
          origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
					pantalla: "formulario de pago",
					nombreServicio: props.serviceInfo && props.serviceInfo.serviceName ,
					tipoElemento: "boton",
					tagTipoElemento: "modal",
					nombreElemento: "cerrar",
					trackAction: true,
					isTelcel: true
				}, true);					
			} else {
				props.executeTaggeo({
					eventName: "pay_service_or_tae",
					seccion: "servicios",
					subseccion: props.serviceInfo && props.serviceInfo.serviceId && getServicesTelcel(props.serviceInfo.serviceId),
          origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
					pantalla: "formulario de pago",
					nombreServicio: props.serviceInfo && props.serviceInfo.serviceName ,
					tipoElemento: "boton",
					tagTipoElemento: "modal",
					nombreElemento: "cerrar",
					trackAction: true,
				}, true);
			}
		} else {
			props.executeTaggeo({
				step: "Formulario de pago",
				action: "Click modal Cerrar",
				modal_id: props.addCardFormData.isOpenAddCardForm ? "Ingresa una tarjeta" : "Elige método de pago"
			});
		}
	}

	const cleanAddCardFormData = () => {
		props.setAddCardFormData({ 
			...props.addCardFormData,
			creditCardNumberValue: undefined,
			cvvValue: undefined,
			expirationCardValue: undefined,
			inputsError: [],
			isOpenAddCardForm: false,
			paymentMethodSelected: undefined,
			showError: false,
			typeCard: undefined,
			userNameValue: undefined
		});
	}

	const getCardCustomer = async () => {
		const cardCustomer = await useClaropaySdk().isCardCustomer(
			props.userInfo && 
			props.userInfo["claro-profile.person.claroid"] ? 
			props.userInfo["claro-profile.person.claroid"] : ""
		);
		return cardCustomer
	}

	useEffect(() => {	
		if (props.isOpen && !props.addCardFormData.isOpenAddCardForm && !props.isAnonimous) {
			getCardCustomer().then((res) => {
				if (!JSON.parse(res).success) {
					seTIsEmailBackgroud(true)
				}
			})			
		}
	}, [props.isOpen, props.addCardFormData.isOpenAddCardForm, props.isAnonimous]);

	const closeTokenizationCard =  (e) => {
		props.closeTokenizationCard(e)
		cleanAddCardFormData(),
		seTIsEmailBackgroud(false);
	}
	return (
		!props.isUnificationFlow ?
				<ClaroModalCustom isOpen={props.isOpen} backgroundColor={props.backgroundColor}>
					<ClaroCardSimple
						backgroundColor={props.addCardFormData.isOpenAddCardForm ? "#ffffff" : "#f6f6f6"}
						borderRadius='15px 15px 0px 0px'
						margin='0px'
						height={props.height}
						style={{ width:"100%",	position: "fixed", bottom: "0px" }}
						fadeIn={props.fadeIn}
										fadeInTime={props.fadeInTime}
										cubicBezier={props.cubicBezier}
										addCloseEfect = {props.addCloseEfect}>

						{/* Back and close buttons */}
						<div style={{ height: '20px', width: '100%' }}>
							{
								props.addCardFormData.isOpenAddCardForm &&
								<img 
									style={{ float: 'left' }}
									src={`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}cap_scr_ct_card_form_back.png`}
									width="24px"
									height="24px"
									onClick={
										() => {
											cleanAddCardFormData(),
											sendTaggeoBack()
										}
									} />
							}
							
							<img 
								style={{ float: 'right' }}
								src={`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}cap_src_ct_alerts_close.png`}
								width="24px"
								height="24px"
								onClick={
									() => {
										props.handleCloseSelectCardAnonimous(), 
										cleanAddCardFormData(),
										sendTaggeoClose("modal")
									}
								} />
						</div>
				
						{
							!props.addCardFormData.isOpenAddCardForm &&
							<PaymentMethodsList
								{...props}
								setAddCardForm={props.setAddCardFormDataHandler}
							/>
						}

						{
							props.addCardFormData.isOpenAddCardForm &&
							<AddCardForm {...props} />
						}
					</ClaroCardSimple>
				</ClaroModalCustom>
		:
				/// Flow of unification flow
				props.isAnonimous || !props.isAnonimous  && !isEmailBackgroud  ?
					<ClaroModalCustom isOpen={props.isOpen} backgroundColor={props.backgroundColor}>
						<ClaroCardSimple
							backgroundColor={props.addCardFormData.isOpenAddCardForm ? "#ffffff" : "#f6f6f6"}
							borderRadius='15px 15px 0px 0px'
							margin='0px'
							height={"auto"}
							style={{ width:"100%",	position: "fixed", bottom: "0px" }}
							fadeIn={props.fadeIn}
							fadeInTime={props.fadeInTime}
							cubicBezier={props.cubicBezier}
							addCloseEfect = {props.addCloseEfect}>
		
							{/* Back and close buttons */}
							<div style={{ height: '20px', width: '100%' }}>
								{
									props.addCardFormData.isOpenAddCardForm &&
									<img 
										style={{ float: 'left' }}
										src={`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}cap_scr_ct_card_form_back.png`}
										width="24px"
										height="24px"
										onClick={
											() => {
												cleanAddCardFormData(),
												sendTaggeoBack()
											}
										} />
								}
								
								<img 
									style={{ float: 'right' }}
									src={`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}cap_src_ct_alerts_close.png`}
									width="24px"
									height="24px"
									onClick={
										() => {
											props.handleCloseSelectCardAnonimous(), 
											cleanAddCardFormData(),
											sendTaggeoClose("modal")
										}
									} />
							</div>
							{
								!props.addCardFormData.isOpenAddCardForm &&
								<PaymentMethodsList
									{...props}
									setAddCardForm={props.setAddCardFormDataHandler}
								/>
							}
		
							{
								props.addCardFormData.isOpenAddCardForm &&
								<TokenizationCardContainer 
									{...props} 
									closeTokenizationCard={closeTokenizationCard}
									isComingFromMicroApp={true}
									height={"75vh"}
									singlePageConfig ={{
										allWidth: false,
										buttonLabel: "Continuar",
										autofocus: false,
										backgroundColor: "white",
									}} 
								/>
							}
						</ClaroCardSimple>
					</ClaroModalCustom>
				: 
				!props.isAnonimous && isEmailBackgroud && props.addCardFormData.isOpenAddCardForm ?
					<ClaroCardSimple
						backgroundColor={props.addCardFormData.isOpenAddCardForm ? "#ffffff" : "white"}
						borderRadius='15px 15px 0px 0px'
						margin='0px'
						padding='0px'
						height={"100%"}
						style={{ width:"100%",	position: "fixed", bottom: "0px" }}
						addCloseEfect = {props.addCloseEfect}>
							<TokenizationCardContainer 
								{...props} 
								showHeader={true}
								isComingFromMicroApp={true}
								closeTokenizationCard={closeTokenizationCard}
								singlePageConfig ={{
									allWidth: false,
									buttonLabel: "Continuar",
									autofocus: false,
									backgroundColor: "white",
								}} 
							/>
					</ClaroCardSimple>
				: 	
				<ClaroModalCustom isOpen={props.isOpen} backgroundColor={props.backgroundColor}>
					<ClaroCardSimple
						backgroundColor={props.addCardFormData.isOpenAddCardForm ? "#ffffff" : "#f6f6f6"}
						borderRadius='15px 15px 0px 0px'
						margin='0px'
						height={"auto"}
						style={{ width:"100%",	position: "fixed", bottom: "0px" }}
						fadeIn={props.fadeIn}
						fadeInTime={props.fadeInTime}
						cubicBezier={props.cubicBezier}
						addCloseEfect = {props.addCloseEfect}>
						{/* Back and close buttons */}
						<div style={{ height: '20px', width: '100%' }}>
							{
								props.addCardFormData.isOpenAddCardForm &&
								<img 
									style={{ float: 'left' }}
									src={`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}cap_scr_ct_card_form_back.png`}
									width="24px"
									height="24px"
									onClick={
										() => {
											cleanAddCardFormData(),
											sendTaggeoBack()
										}
									} />
							}
							<img 
								style={{ float: 'right' }}
								src={`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}cap_src_ct_alerts_close.png`}
								width="24px"
								height="24px"
								onClick={
									() => {
										props.handleCloseSelectCardAnonimous(), 
										cleanAddCardFormData(),
										sendTaggeoClose("modal")
									}
							} />
						</div>
						{
							!props.addCardFormData.isOpenAddCardForm &&
							<PaymentMethodsList
								{...props}
								setAddCardForm={props.setAddCardFormDataHandler}
							/>
						}
					</ClaroCardSimple>
				</ClaroModalCustom>
	)
}

const mapStateToProps = (state) => {
    const { payments } = state;
	const addCardFormData = payments.addCardFormData;

    return {
		addCardFormData
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            setAddCardFormData,
			executeTaggeo
        },
        dispatch,
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectCardAnonimous)
